import { useGlobalDIContext } from '@context/GlobalDIContext';
import { UserInfo } from '@g2-shared/api-client/generated/direct-money-gateway-app';
import { getServerErrorMessage } from '@g2-shared/common';
import { useQuery } from 'react-query';
import { FETCH_AUTH_USER, useUserApiDefaultConfig } from '../../config';

interface useFetchAuthenticatedUserInterface {
  user?: UserInfo | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  errorMessage: string;
  refetch: () => Promise<any>;
}

export const useGetUserInfo = (enabled?: boolean): useFetchAuthenticatedUserInterface => {
  const config = useUserApiDefaultConfig('useGetUserInfo');
  const { DirectMoneyApiClient } = useGlobalDIContext();

  const { data, isLoading, error, refetch } = useQuery(
    [FETCH_AUTH_USER],
    // @ts-ignore
    async () => {
      try {
        const response = await DirectMoneyApiClient.getUserInfo();
        return response.data.result;
      } catch (e: any) {
        console.log('GRESKA!!', e);
      }
    },
    {
      refetchOnReconnect: false,
      retry: false,
      staleTime: 2000,
      enabled,
    }
  );

  return {
    user: data,
    isLoading,
    isAuthenticated: !isLoading && !!data,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
    refetch,
  };
};
